module.exports = __webpack_public_path__ + "fonts/Source_Serif_4-normal-900-greek.e0ac98f.woff2";